var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lnb-list"},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.moveToUrl()}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('NextButtonWhite')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }